import { Box, Typography } from "@mui/material";
type ImageSliderProps = {
  src: string;
  label: string;
  alt: string;
  labelColor: string;
};
export const ImageSlider = ({ src, label, alt, labelColor }: ImageSliderProps) => {
  return (
    <>
      <Box
        component="img"
        sx={{
          width: "100%",
          height: "100%",
          borderRadius: 5
        }}
        src={src}
        alt={alt}
      />
      <Typography
        overflow="hidden"
        textOverflow="ellipsis"
        width="90%"
        position="absolute"
        bottom={20}
        marginLeft={5}
        color={labelColor}>
        {label}
      </Typography>
    </>
  );
};
